import { RouterProvider } from 'react-router';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { toast, Toaster } from 'sonner';

import routes from './routes';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (err, query) => {
      if (query.meta?.silentError) return;
      // One toast per message: several queries failing together (e.g. the
      // API is down) would otherwise stack identical "Network Error" toasts.
      toast.error(err.message, { id: err.message });
    },
  }),
  // mutationCache: new MutationCache({
  //   onError: err => {
  //     toast.error(err.message);
  //   },
  // }),
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

const App = () => {
  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={routes} />
        <Toaster position="top-right" richColors />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </div>
  );
};

export default App;
